import { createReducer, on } from '@ngrx/store';
import { PageLoaderActions } from './page-loader.actions';

export const initialPageLoaderState = true;

export const pageLoaderReducer = createReducer(
  initialPageLoaderState,
  on(PageLoaderActions.showPageLoader, () => true),
  on(PageLoaderActions.hidePageLoader, () => false),
);
